export default __webpack_public_path__ + "static/play button_Trio_Final-de04470f06fe35f6d7dba897a6aacddf.png";